import { useQuery } from "@tanstack/react-query";
import { useCartService } from "./use-cart-service";

const fetchRecommendations = async (productIds: string[]) => {
	if (productIds.length === 0) {
		return [];
	}

	const response = await fetch(`/api/recommendations`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ productIds }),
	});

	if (!response.ok) {
		throw new Error("Failed to fetch recommendations");
	}

	return response.json() as Promise<Queries.CommerceToolsProduct[]>;
};

export function useCartRecommendations({
	amount,
}: {
	amount?: number;
} = {}) {
	const { cart } = useCartService();

	const productIds = cart?.lineItems.map((item) => item.productId) || [];

	const { data: recommendations = [], status } = useQuery({
		queryKey: ["recommendations", productIds],
		queryFn: () => fetchRecommendations(productIds),
	});

	// Filter out products that are already in the cart
	const filteredRecommendations = recommendations.filter((recommendation) => {
		return !productIds.includes(recommendation.id);
	});

	return {
		recommendations: amount
			? filteredRecommendations.slice(0, amount)
			: filteredRecommendations,
		status,
	};
}
